/*global $, jQuery, alert, console*/
(function () {
    "use strict";
    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows() );
        }
    };



    $(document).ready(function () {
        var source, medium, term, content, campaign, session_count, pageview_count;

        function get_campaign_info() {
            var utma = get_utm_value(document.cookie, '__utma=', ';');
            var utmb = get_utm_value(document.cookie, '__utmb=', ';');
            var utmc = get_utm_value(document.cookie, '__utmc=', ';');
            var utmz = get_utm_value(document.cookie, '__utmz=', ';');

            source = get_utm_value(utmz, 'utmcsr=', '|');
            medium = get_utm_value(utmz, 'utmcmd=', '|');
            term = get_utm_value(utmz, 'utmctr=', '|');
            content = get_utm_value(utmz, 'utmcct=', '|');
            campaign = get_utm_value(utmz, 'utmccn=', '|');

            session_count = get_session_count(utma);
            pageview_count = get_pageview_count(utmb, utmc);
        }

        function get_utm_value(l, n, s) {
            if (!l || l == "" || !n || n == "" || !s || s == "") return "-";
            var i, j, k, utm = "-";
            i = l.indexOf(n);
            k = n.indexOf("=") + 1;

            if (i > -1) {
                j = l.indexOf(s, i);
                if (j < 0) {
                    j = l.length;
                }
                utm = l.substring((i + k), j);
            }
            return utm;
        }

//This function extracts the "Count of Sessions" value from the _utma cookie
        function get_session_count(str) {
            var i, vc = '-';
            if (str != '-') {
                i = str.lastIndexOf(".");
                i++;
                vc = str.substring(i);
            }
            return vc;
        }

//This function extracts the "Count of Pageviews" value from the _utmb cookie
        function get_pageview_count(utmb, utmc) {
            var i, j, pc = '-';
            if (utmb != '-' && utmc != '-') {
                utmc = utmc + '.';

                i = utmc.length;
                j = utmb.indexOf(".", i);
                pc = utmb.substring(i, j);
            }
            return pc;
        }

        get_campaign_info();

        $('div.formWP').append('<div style="display:none"><input type="hidden" name="p" value="">' +
            '<input type="hidden" name="client_id" value="">' +
            '<input type="hidden" name="campaign_source" value="">' +
            '<input type="hidden" name="campaign_channel" value="">' +
            '<input type="hidden" name="campaign_name" value="">' +
            '<input type="hidden" name="search_queries" value="">' +
            '<input type="hidden" name="session_count" value="">' +
            '<input type="hidden" name="keyword_match_type" value="keyword">' +
            '<input type="hidden" name="utm_term" value="">' +
            '<input type="hidden" name="device" value=""></div>');


        $('input[name="url_page"]').val(window.location.href);

        var date = new Date(new Date().getTime() + 60 * 48 * 3600 * 1000);

        $('input[name="session_count"]').val(session_count);

        $('input[name="keyword_match_type"]').val('keyword');

        function getCookie(name) {
            var matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
            ));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }

        /**
         * BEGIN: UTM метки
         * все метки вида utm_.* в query части запроса должны обрабатыватся
         */

        var queryDict = {};

        var search = location.href.split("?");

        if (search) {
            search.shift();
            search.join('&').split("&").forEach(function (item) {
                queryDict[item.split("=")[0]] = item.split("=")[1];
            });
        }

        var utm_list = [
            {key: 'p', sugar: 'p'},
            {key: 'utm_source', sugar: 'campaign_source'},
            {key: 'utm_medium', sugar: 'campaign_channel'},
            {key: 'utm_campaign', sugar: 'campaign_name'},
            {key: 'utm_content', sugar: 'ad_group'},
            {key: 'utm_term', sugar: 'utm_term'},
            {key: 'utm_term', sugar: 'search_queries'},
            {key: 'device', sugar: 'device'},
        ];

        utm_list.forEach(function (utm_item) {
            utm_item.val = '';
            if (getCookie(utm_item.key) !== "undefined") {
                utm_item.val = getCookie(utm_item.key);
            }
            if (typeof queryDict[utm_item.key] !== "undefined") {
                document.cookie = utm_item.key + "=" + queryDict[utm_item.key] + ";path=/;expires=" + date.toUTCString();
                utm_item.val = decodeURIComponent(queryDict[utm_item.key]);
            }
            $('input[name="' + utm_item.sugar + '"]').val(utm_item.val);

            if (utm_item.key === 'utm_source' && utm_item.val === 'influ2') {
                $('input[name="p"]').val(utm_item.val);
            }
        });

        if (window.location.href.indexOf("utm_campaign") > -1) {
            document.cookie = 'url_page' + "=" + window.location.href + ";path=/;expires=" + date.toUTCString();
        }

        /**
         * END: UTM метки
         */
        $(document).change(function () {
            if(ga.length){
                $('input[name="client_id"]').val(ga.getAll()[0].get('clientId'));
                $('input[name="gcl_id"]').val(ga.getAll()[0].get('_gclid'));
            }
        });
    });

    gdprCookieNotice({
        locale: 'en', //This is the default value
        timeout: 500, //Time until the cookie bar appears
        expiration: 60, //This is the default value, in days
        domain: '.altoros.no', //If you run the same cookie notice on all subdomains, define the main domain starting with a .
        implicit: false, //Accept cookies on page scroll automatically
        statement: 'https://www.altoros.no/altoros_personvernregler.html', //Link to your cookie statement page
        performance: ['JSESSIONID', '_hjIncludedInSample', 'nQ_visitId', 'nQ_cookieId', 'locale', 'lang', '__atuvc', '__hstc', '__hssrc', '__hssc', 'hsfirstvisit', 'hubspotutk'], //Cookies in the performance category.
        analytics: ['ga', '_ga', '_gid', '_gat', 'collect', '_ga_user_id', '__utmz', '__utma', 'gwcc'], //Cookies in the analytics category.
        marketing: ['SSID', 'IDE', 'test_cookie', 'fr', 'tr', '1P_JAR', 'id', 'NID', 'APISID', 'SAPISID', 'guest_id', 'personalization_id', 'bcookie', 'bscookie', 'lidc', 'MUID', 'MUIDB', 'GPS'] //Cookies in the marketing category.
    });

    $(document).ready(function () {
        addInlineSvg();
        detectSeenElements();
        function detectSeenElements() {
            var sections = $('.s-portfolio__block, .s-expertise-tab-descr, .s-team__content');


            $(window).on('scroll', function () {
                var cur_pos = $(this).scrollTop();

                sections.each(function() {
                    var top = $(this).offset().top - $( window ).height()/2,
                        bottom = top + $(this).outerHeight();
                    $(this).removeClass('visible');
                    if (cur_pos >= top && cur_pos <= bottom) {
                        $(this).addClass('visible');
                        $(this).addClass('seen');
                    }
                });
            });
            var cur_pos = $(window).scrollTop();

            sections.each(function() {
                var top = $(this).offset().top - $( window ).height()/2,
                    bottom = top + $(this).outerHeight();
                $(this).removeClass('visible');
                if (cur_pos >= top && cur_pos <= bottom) {
                    $(this).addClass('visible');
                    $(this).addClass('seen');
                }

            });
        }
        function addInlineSvg() {
            $('img.image_svg').each(function(){
                var $img = jQuery(this);
                var imgID = $img.attr('id');
                var imgClass = $img.attr('class');
                var imgURL = $img.attr('src');

                jQuery.get(imgURL, function(data) {
                    // Get the SVG tag, ignore the rest
                    var $svg = jQuery(data).find('svg');

                    // Add replaced image ID to the new SVG
                    if(typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }
                    // Add replaced image classes to the new SVG
                    if(typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass+' replaced-svg');
                    }

                    // Remove any invalid XML tags as per http://validator.w3.org
                    $svg = $svg.removeAttr('xmlns:a');

                    // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                    if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                        $svg.attr('viewBox', '0 0 ' + $svg.attr('width') + ' ' + $svg.attr('height'))
                    }

                    // Replace image with new SVG
                    $img.replaceWith($svg);

                }, 'xml');

            });
        }

        $('.tabs').tabs();


        $('input[name="url_page"]').val($('input[name="url_page"]').val() + window.location.search);

        var cookie = window.location.search.split('&')[0].replace("?p=", "");
        $('input[name="p"]').val(cookie);

        // $('input[name="client_id"]').val(ga.getAll()[0].get('clientId'));
        $('input[name="session_count"]').val(session_count);

        //$('input[name="campaign_channel"]').val(medium);
        //$('input[name="campaign_source"]').val(source);
        //$('input[name="search_queries"]').val(term);

        $('input[name="keyword_match_type"]').val('keyword');
        //$('input[name="ad_group"]').val(ga.getAll()[0].get('adGroup'));

        var str = decodeURIComponent(window.location.href);
        //console.log(str);

        var ar = str.split(/&|#|\//);
        //console.log(ar);

        var newStr = '';
        var newStrCampaign = '';
        var newStrMedium = '';
        var newStrSource = '';

        for (var i = 0; i < ar.length; i++) {
            if (ar[i].search(/utm_term/i) >= 0) {
                newStr = ar[i];
                newStr = newStr.replace('utm_term=', "");
                $('input[name="utm_term"]').val(newStr);
                $('input[name="search_queries"]').val(newStr);
            }

            if (ar[i].search(/utm_campaign/i) >= 0) {
                newStrCampaign = ar[i];
                newStrCampaign = newStrCampaign.replace('utm_campaign=', "");

                loadJSON(function (response) {

                        var jsonresponse = JSON.parse(response);

                        for (var key in jsonresponse) {
                            if (newStrCampaign == jsonresponse[key].campaign_id) {
                                newStrCampaign = jsonresponse[key].campaign_name;
                                $('input[name="campaign_name"]').val(newStrCampaign);
                            }
                            else {
                                $('input[name="campaign_name"]').val(newStrCampaign);
                            }
                        }
                    }
                );
            }

            if (ar[i].search(/utm_medium/i) >= 0) {
                newStrMedium = ar[i];
                newStrMedium = newStrMedium.replace('utm_medium=', "");
                $('input[name="campaign_channel"]').val(newStrMedium);
            }

            if (ar[i].search(/utm_source/i) >= 0) {
                newStrSource = ar[i];
                newStrSource = newStrSource.replace('utm_source=', "");
                $('input[name="campaign_source"]').val(newStrSource);
                //console.log($('input[name="campaign_source"]').val());
            }
        }

    });

    $(document).change(function () {
        if (ga.length) {
            $('input[name="client_id"]').val(ga.getAll()[0].get('clientId'));
        }
    });

    $(document).ready(function () {
        $('.s-partners__content').slick({
            variableWidth: true,
            arrows: false,
            centerMode: true,
            infinite: true,
            dots: false,
            autoplay: true,
            cssEase: 'linear',
            autoplaySpeed: 0,
            speed: 2000,
            draggable: false,
            pauseOnFocus: false,
            pauseOnHover: false
        });
        $('.animated-scroll').on('click', function (e) {
            var linkHref = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(linkHref).offset().top
            }, 500);
        });

        $('.modal').modal();

        if ($(window).width() <= 992) {
            $('.s-expertise-tabs').slick({
                variableWidth: true,
                arrows: false,
                centerMode: false,
                infinite: false
            })
        }

        $(window).resize(function() {
            if ($(window).width() <= 992 && !$('.s-expertise-tabs').hasClass('slick-slider')) {
                $('.s-expertise-tabs').slick({
                    variableWidth: true,
                    arrows: false,
                    centerMode: false,
                    infinite: false
                })
            } else if ($(window).width() > 992 && $('.s-expertise-tabs').hasClass('slick-slider')) {
                $('.s-expertise-tabs').slick('unslick');
            }
        })



    });


    controlStepForm();
    function controlStepForm() {
        $('.step-btn_next').on('click', function (e) {
            e.preventDefault();
            var flag = false;
            $(this).closest('.step-block').find('.form-control').each(function () {
                if($(this).hasClass('invalid')) {
                    flag = false;
                    return false;
                } else {
                    flag = true;
                }
            });

            if(flag) {
                $(this).closest('.step-block').removeClass('active').next('.step-block').addClass('active');
                $(this).closest('form').find('.form-control').each(function() {
                    $(this).removeClass('invalid');
                })
                $(this).closest('form').find('.form-error').each(function() {
                    $(this).remove();
                })
            }
        });

        $('.step-btn_back').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.step-block').removeClass('active').prev('.step-block').addClass('active');
        })
    }
    contactFormsConfig();
    function contactFormsConfig() {
        try {
            $('input[name=url_page]').val(location.origin + location.pathname);
            // $('input[name=lead_source_description]').val('AltorosLabs | '+ location.pathname);
        }catch (e) {

        }
    }
    // var Persona = {
    //     api_url: "https://www.altoros.no/api.html"
    // };
    // $("form#bottomForm").on("submit", function (event) {
    //     event.preventDefault();
    //     var sendBtn = $(this).find('.submitButton');
    //     var preloaderBtn = $(this).find('.preloader-wrapper-btn');
    //
    //     sendBtn.hide();
    //     preloaderBtn.show();
    //     //need validate if Ok:
    //
    //     // var data_set = {action: 'sent_form', form_data: $( this ).serialize(), form_type: 'help_build_team'};
    //
    //     $.post(Persona.api_url, $(this).serialize()).done(function () {
    //         location.href = 'http://www.altoros.no/kontakt_oss_takk.html';
    //     }).fail(function () {
    //         alert('Sorry, an error has occurred, please try again!');
    //         sendBtn.show();
    //         preloaderBtn.hide();
    //     });
    //     return false;
    // });
})();


